import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

interface Props {
    children: React.ReactNode | React.ReactNode[];
}

export function Modal({ children }: Props) {
    const modalRoot = document.getElementById('modal-root');
    const elementRef = useRef(document.createElement('div'));

    useEffect(() => {
        if (!modalRoot) return;
        const element = elementRef.current;
        modalRoot.appendChild(element);

        return () => {
            modalRoot.removeChild(element);
        };
    }, [modalRoot]);

    return ReactDOM.createPortal(children, elementRef.current);
}
